// Registro de quem sabe guiar cada módulo.
//
// O problema: `startTaskNavigation` é o caminho único de "Iniciar etapa" — o
// accordion da Jornada, a barra embutida na Visão Geral do módulo, o card da
// Home e o CTA das telas de boas-vindas passam todos por ele. Para que TODAS
// essas superfícies guiem, o tour tem de arrancar ali. Mas os seletores são
// dado do MÓDULO, e `central-config` não pode importar `fee-fixo`.
//
// A inversão: o módulo se REGISTRA no bootstrap (`fee-fixo/index.js`), e o
// central-config só consulta. A seta de dependência continua apontando para cá.
//
// Módulo sem provedor registrado ⇒ comportamento de sempre (navega e abre o
// drawer de texto). Nada quebra por ausência.

const provedores = {}

/**
 * @param {String}   moduleKey  slug do módulo no catálogo ('fee-fixo')
 * @param {Function} montar     ({ store, moduleId, task }) => payload | null
 *                              O payload vai direto para a action `iniciarTour`.
 *                              Devolver null significa "esta etapa não tem tour".
 */
export function registrarTourDoModulo(moduleKey, montar) {
  if (!moduleKey || typeof montar !== 'function') return
  provedores[moduleKey] = montar
}

/**
 * Monta o tour da etapa, se o módulo souber guiá-la.
 * Fail-open: qualquer erro do provedor devolve null e a navegação segue normal —
 * um mapa de seletores torto não pode impedir o usuário de chegar na tela.
 */
export function montarTourDaEtapa({ store, moduleKey, moduleId, task } = {}) {
  const montar = provedores[moduleKey]
  if (!montar || !store || !task) return null
  try {
    return montar({ store, moduleId, task }) || null
  } catch (erro) { // NOSONAR: guiar é opcional; navegar não é
    return null
  }
}

// Só para os testes: o registro é global por design (roda uma vez no bootstrap).
export function limparRegistroDeTours() {
  Object.keys(provedores).forEach((chave) => delete provedores[chave])
}
